import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  AggregateSharesValidationEntry,
  DuplicateFilingsEntry,
  QualityGateFilter,
} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { ViewFilingsComponent } from "../../modals/view-filings/view-filings.component";

@Component({
  selector: "duplicate-app-processed",
  // imports: [],
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class DuplicateProcessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  processedDuplicateFilings: DuplicateFilingsEntry[] = [];
  selectedAggregateShares: any = null;
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  accessionNumber?: string;
  groupFlagChecked = false;
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}
  ngOnInit(): void {}
  getProcessedDuplicateFilings() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "PROCESSED",
      qualityGateType: "Duplicate_Filings",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
        accessionNumber: this.accessionNumber?.trim() === "" ? undefined : this.accessionNumber,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.processedDuplicateFilings = value.duplicateFilingEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedDuplicateFilings?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
   onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedDuplicateFilings();
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedDuplicateFilings();
  }
  viewFilingsModal(rowData: any) {
    this.ref = this.dialogService.open(ViewFilingsComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "60vw" },
      contentStyle: { overflow: "auto" },
      header: "Filings",
      data: {
        fileDetail: rowData,
      },
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getProcessedDuplicateFilings();
      }
    });
  }
}
